import Logger from "../common/utils/Logger";

export enum CompID {
    LandClearing,
    TopSoilManagement,
    Drilling,
    Blasting,
    OBManagement,
    DisposalManagement,
    MudHandling,
    RoadManagement,
    GeneralSupport,
    Dewatering,
    MineWaterTreatment,
    CoalGetting,
    CoalHauling,
    StockpileManagement,
    CoalBlending,
    DraftSurvey,
    WorkReadiness
}

export const CompIDStrings = [
    "Land Clearing",
    "Top Soil Management",
    "Drilling",
    "Blasting",
    "OB Management",
    "Disposal Management",
    "Mud Handling",
    "Road Management",
    "General Support",
    "Dewatering",
    "Mine Water Treatment",
    "Coal Getting",
    "Coal Hauling",
    "Stockpile Management",
    "Coal Blending",
    "Draft Survey",
    "Work Readiness",
];

export const CompIDs: CompID[] = <CompID[]>Object.values(CompID).filter(e => typeof e != 'string');